import type {GenericAbortSignal} from 'axios';

import {Client4} from 'mattermost-redux/client';
import {TimeApiClient} from '@time-webkit/request';
import {type FileInfo} from '@time-webkit/all/utils/attachments';

type GetFileInfoResponse = {success: false} | {success: true; data: FileInfo};

export const getFileInfo: (fileId: FileInfo['id'], signal?: GenericAbortSignal) => Promise<GetFileInfoResponse> = async (fileId, signal) => {
    const requester = TimeApiClient;
    const url = `${Client4.getUrl()}/api/v4/files/${fileId}/info`;

    try {
        const {data} = await requester.get<FileInfo>(url, {signal});

        return {data, success: true};
    } catch {
        return {success: false};
    }
};
